module.exports = __webpack_public_path__ + "static/img/11.7f7954a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/11.png
// module id = h2Ju
// module chunks = 12